import React from "react";
import {
    Menu,
    Box,
    Divider,
    Grid,
    Typography,
    Button,
    ButtonGroup,
    TextField,
    FormHelperText,
    FormControl,
    InputLabel,
    Input,
    IconButton,
} from "@material-ui/core";
import { toast } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';
import UsuarioService from "../../services/usuarioService";
import { useState } from "react";
import useStyles from "./style";
import { Clear } from "@material-ui/icons";

const MenuCardUser = (props) => {
    const classes = useStyles();

    const [senhaDigitosError, setSenhaDigitoErro] = useState({ isError: false, erroMsg: "" });
    const [senhaMaiusculaError, setSenhaMaiusculaErro] = useState({ isError: false, erroMsg: "" });
    const [senhaMinusculaError, setSenhaMinusculaErro] = useState({ isError: false, erroMsg: "" });
    const [senhaNumeroError, setSenhaNumeroErro] = useState({ isError: false, erroMsg: "" });
    const [senhaError, setSenhaErro] = useState({ isError: false, erroMsg: "" });

    const [isRedefinir, setRedefinir] = useState(false);

    const [senha, setSenha] = useState("");
    const [novaSenha, setNovaSenha] = useState("");
    const [novaSenhaConfirmacao, setNovaSenhaConfirmacao] = useState("");
    
    const [senhaConfirmacaoError, setSenhaConfirmacaoErro] = useState({ isError: false, erroMsg: "" });


    const resetErrors = () => {
        if (novaSenhaConfirmacao == "")
            setSenhaErro({ isError: false, erroMsg: ""})
        setSenhaNumeroErro({ isError: false, erroMsg: ""})
        setSenhaMaiusculaErro({ isError: false, erroMsg: ""})
        setSenhaMinusculaErro({ isError: false, erroMsg: ""})
        setSenhaDigitoErro({ isError: false, erroMsg: ""})
    }

    const changeNovaSenha = (e) => {
        resetErrors()
        setNovaSenha(e);
        
        let valid = true;

        if (e.length < 8) {
            setSenhaDigitoErro({ isError: true, erroMsg: "mínimo de oito caracteres"})
            valid = false;
        }
        if (!e.match("(?=.*?[A-Z])")) {
            setSenhaMaiusculaErro({ isError: true, erroMsg: "mínimo de uma letra maiúscula"})
            valid = false;
        } 
        
        if (!e.match("(?=.*?[a-z])")) {
            setSenhaMinusculaErro({ isError: true, erroMsg: "mínimo de uma letra minúscula"})
            valid = false;
        }

        if (!e.match("(?=.*?[0-9])")) {
            setSenhaNumeroErro({ isError: true, erroMsg: "mínimo de um número"})
            valid = false;
        }

        if (novaSenhaConfirmacao != "" && e != novaSenhaConfirmacao) {
            setSenhaConfirmacaoErro({ isError: true, erroMsg: "senha está diferente"})
            valid = false;
        } else {
            setSenhaConfirmacaoErro({ isError: false, erroMsg: ""})
            setSenhaErro({ isError: false})
        }

        if (!valid){
            setSenhaErro({ isError: true})
        }
    }

    const confirmarSenha = (e) => {
        setSenhaConfirmacaoErro({ isError: false, erroMsg: ""})
        
        if (!senhaDigitosError.isError && !senhaMaiusculaError.isError && !senhaMinusculaError.isError && !senhaNumeroError.isError) {
            setSenhaErro({ isError: false})
        }
        setNovaSenhaConfirmacao(e);

        let valid = true;

        if (e!= "" && e!=novaSenha) {
            setSenhaConfirmacaoErro({ isError: true, erroMsg: "senha está diferente"})
            valid = false
        }

        if (!valid){
            setSenhaErro({ isError: true})
        }
    }

    const validaErros = () => {
        if (senhaError.isError) return false 
        if (senhaConfirmacaoError.isError) return false 
        if (senhaDigitosError.isError) return false 
        if (senhaMaiusculaError.isError) return false 
        if (senhaMinusculaError.isError) return false 
        if (senhaNumeroError.isError) return false 

        return true;
    }

    const redefinirSenha = async() => {
        if (senha != "" && novaSenha != "" && novaSenhaConfirmacao != "" && validaErros()) {
            let newPassword = {
                "senha_atual": senha,
                "senha_nova": novaSenha
            }
    
            await UsuarioService.alterarSenha(newPassword).then((data)=> {
                props.handleMenuClose();
                setRedefinir(false)
                toast.success("Senha Atualizada com Sucesso!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }).catch((erro) => {
                toast.error(erro.detail, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
        } else {
            toast.error("Preencha os campos corretamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }


    const cancelButton = () => {
        setRedefinir(false)
        
        setSenhaDigitoErro({ isError: false, erroMsg: "" });
        setSenhaMaiusculaErro({ isError: false, erroMsg: "" });
        setSenhaMinusculaErro({ isError: false, erroMsg: "" });
        setSenhaNumeroErro({ isError: false, erroMsg: "" });
        setSenhaErro({ isError: false, erroMsg: "" });
        setSenhaConfirmacaoErro({ isError: false, erroMsg: "" });
    
    
        setSenha("");
        setNovaSenha("");
        setNovaSenhaConfirmacao("");
    }

    return (
        <Menu
        anchorEl={props.anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={props.menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "3.3rem" }}
        open={props.isMenuOpen}
        onClose={props.handleMenuClose}
    >
        <Box width="17rem">
        { isRedefinir != true ?
            <Grid container justifyContent="center">
                <Grid item xs={12}>
                    <Typography variant="h6" align="center">
                        {UsuarioService.getNome()}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" align="center">
                        {UsuarioService.getEmail()}
                    </Typography>
                </Grid>
                {/* <Button
                    variant="outlined"
                    size="small"
                    style={{
                        height: "1.3rem",
                        margin: "1rem",
                        borderRadius: "15px",
                    }}
                >
                    Gerencie sua conta
                </Button> */}
                <Grid item xs={12}>
                    <Divider light />
                </Grid>
            </Grid>
                : <Grid >
                    <p style={{opacity : 0}}>&apos;</p>
                </Grid>}
                { isRedefinir == true ?
                <Grid >
                    <Grid item xs={12}>
                            <Grid item xs={12}>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error={senhaError.isError}
                                >
                                <TextField
                                    id="senha"
                                    type="password"
                                    value={senha}
                                    label="Senha Atual"
                                    size="small"
                                    variant="outlined"
                                    fullWidth={true}
                                    onChange={(e) => setSenha(e.target.value)}
                                >
                                </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                
                                <FormControl
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={senhaError.isError}
                                        >
                                <Grid item xs={12}>
                                <div className={classes.margin}>
                                <TextField xs={12}
                                    error={senhaError.isError}
                                    helperText={senhaError.erroMsg}
                                    type="password"
                                    value={novaSenha}
                                    size="small"
                                    label="Nova Senha"
                                    variant="outlined"
                                    fullWidth={true}
                                    onChange={(e) => changeNovaSenha(e.target.value)}
                                >
                                </TextField>
                                </div>
                                <div className={classes.margin}>
                                <TextField xs={12}
                                    error={senhaError.isError}
                                    type="password"
                                    value={novaSenhaConfirmacao}
                                    size="small"
                                    label="Confirme a Senha"
                                    variant="outlined"
                                    fullWidth={true}
                                    onChange={(e) => confirmarSenha(e.target.value)}
                                >
                                </TextField>
                                </div>
                                <FormHelperText>
                                    {senhaDigitosError.erroMsg}
                                </FormHelperText>
                                <FormHelperText>
                                    {senhaNumeroError.erroMsg}
                                </FormHelperText>
                                <FormHelperText>
                                    {senhaMaiusculaError.erroMsg}
                                </FormHelperText>
                                <FormHelperText>
                                    {senhaMinusculaError.erroMsg}
                                </FormHelperText>

                                <FormHelperText>
                                    {senhaConfirmacaoError.erroMsg}
                                </FormHelperText>
                                </Grid>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} align="center">
                                <ButtonGroup disableElevation variant="container">
                                    <IconButton
                                        variant="outlined"
                                        size="small"
                                        style={{ margin: "1rem" }}
                                        onClick={cancelButton} 
                                    >
                                       <Clear />
                                    </IconButton>
                                    <Button
                                    variant="outlined"
                                    size="small"
                                    style={{ margin: "1rem" }}
                                    onClick={redefinirSenha}
                                    >
                                        Atualizar Senha
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    {/* </Grid> */}
                </Grid>
                :
                <ButtonGroup 
                    disableElevation
                    variant="contained"
                    >
                    <Button
                        variant="outlined"
                        size="small"
                        style={{ margin: "1rem" }}
                        onClick={(e) => setRedefinir(true)}
                    >
                        Redefinir Senha
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        style={{ margin: "1rem" }}
                        onClick={props.logout}
                    >
                        Sair
                    </Button>
                </ButtonGroup>
                }
                <Grid item xs={12}>
                    <Divider light />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" align="center">
                        Politica de privacidade
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" align="center">
                        Termos de Serviço
                    </Typography>
                </Grid>
            
        </Box>
    </Menu>
    );
    }

export default MenuCardUser;
